import axios from "axios";

const config = {
  withCredentials: true,
  headers: {
    withCredentials: true,
  },
};

const cleanParam = (value) => {
  if (value == null) return "";
  const text = String(value).trim();
  if (!text || text === "null" || text === "undefined" || text === "All") {
    return "";
  }
  return text;
};

const getResult = (data) => data?.data?.result;

const buildQuery = (inputs = {}) => {
  const urlParams = new URLSearchParams();
  const orderType = cleanParam(inputs.order_type);
  const shipmentNo = cleanParam(inputs.shipment_no);
  const boxNo = cleanParam(inputs.box_no);
  const portNo = cleanParam(inputs.port_no || inputs.port_no_and_name);

  if (orderType) urlParams.set("order_type", orderType);
  if (shipmentNo) urlParams.set("shipment_no", shipmentNo);
  if (boxNo) urlParams.set("box_no", boxNo);
  if (portNo) urlParams.set("port_no", portNo);

  return urlParams.toString();
};

export const getShipmentPackingListShipments = async (inputs = {}) => {
  try {
    const query = buildQuery({ order_type: inputs.order_type });
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/reports/shipment-packing-list-shipments${
        query ? `?${query}` : ""
      }`,
      config
    );
    return getResult(data) || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getShipmentPackingListBoxes = async (inputs = {}) => {
  try {
    const query = buildQuery({
      order_type: inputs.order_type,
      shipment_no: inputs.shipment_no,
    });
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/reports/shipment-packing-list-boxes${
        query ? `?${query}` : ""
      }`,
      config
    );
    return getResult(data) || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const getShipmentPackingListPorts = async (inputs = {}) => {
  try {
    const query = buildQuery({
      order_type: inputs.order_type,
      shipment_no: inputs.shipment_no,
      box_no: inputs.box_no,
    });
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/reports/shipment-packing-list-ports${
        query ? `?${query}` : ""
      }`,
      config
    );
    return getResult(data) || [];
  } catch (error) {
    console.log(error);
    return [];
  }
};

export const downloadShipmentPackingListReport = async (inputs = {}) => {
  try {
    const query = buildQuery(inputs);
    const data = await axios.get(
      `${process.env.REACT_APP_URL}/api/reports/shipment-packing-list-excel${
        query ? `?${query}` : ""
      }`,
      config
    );
    const result = getResult(data);
    if (typeof result === "string" && /^https?:\/\//i.test(result.trim())) {
      return { url: result.trim(), message: data?.data?.message };
    }
    return {
      url: null,
      message: data?.data?.message || "No Result Found",
    };
  } catch (error) {
    console.log(error);
    return {
      url: null,
      message: error?.response?.data?.message || "No Result Found",
    };
  }
};
